import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    bugReportsControllerCreateBugReportV1: build.mutation<
      BugReportsControllerCreateBugReportV1ApiResponse,
      BugReportsControllerCreateBugReportV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/bug-reports`,
        method: 'POST',
        body: queryArg.createBugReportBody,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type BugReportsControllerCreateBugReportV1ApiResponse = unknown;
export type BugReportsControllerCreateBugReportV1ApiArg = {
  createBugReportBody: CreateBugReportBody;
};
export type CreateBugReportBody = {
  /** Issue title, e.g. "Bug in the app" */
  title: string;
  /** Issue description */
  description: string;
  /** Issue priority, 0 - no priority, 1 - urgent, 2 - high, 3 - medium, 4 - low */
  priority?: number;
};
